import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const SwipeSortBy = ({ open, onClose, setReqBody, reqBody }) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [selectedValue, setSelectedValue] = useState(reqBody.sort_by || 0);

  const sortByUnits = [
    { value: 1, label: "Harga Terendah" },
    { value: 2, label: "Harga Tertinggi" },
    { value: 3, label: "Nama Produk (A - Z)" },
    { value: 4, label: "Nama Produk (Z - A)" },
  ];

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const fn = () => setIsDesktop(mq.matches);
    fn();
    mq.addEventListener("change", fn);
    return () => mq.removeEventListener("change", fn);
  }, []);

  useEffect(() => {
    if (open) {
      setSelectedValue(reqBody.sort_by ?? 0);
    }
  }, [open, reqBody.sort_by]);

  const handleSelect = (value) => {
    setSelectedValue(value);
    setReqBody({ ...reqBody, sort_by: value });
    onClose();
  };

  const panelClass = isDesktop
    ? "fixed left-1/2 top-1/2 z-[9999] flex max-h-[85vh] w-[calc(100%-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 flex-col rounded-2xl bg-white shadow-2xl text-base"
    : "fixed bottom-0 left-0 right-0 z-[9999] flex max-h-[70vh] flex-col rounded-t-3xl bg-white shadow-2xl text-base";

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[9999] bg-black bg-opacity-50"
            onClick={onClose}
          />

          <motion.div
            initial={
              isDesktop ? { opacity: 0, scale: 0.96 } : { y: "100%" }
            }
            animate={isDesktop ? { opacity: 1, scale: 1 } : { y: 0 }}
            exit={isDesktop ? { opacity: 0, scale: 0.96 } : { y: "100%" }}
            transition={{ type: "spring", damping: 28, stiffness: 320 }}
            className={panelClass}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex flex-col gap-2 border-b border-slate-100 px-4 pb-3 pt-4 md:flex-row md:items-center md:justify-between md:pt-5">
              {!isDesktop && (
                <div className="flex w-full justify-center md:hidden">
                  <div className="h-1.5 w-[25%] rounded-full bg-gray-200" />
                </div>
              )}
              <h2 className="text-lg font-semibold text-slate-900">Urutan</h2>
              {isDesktop && (
                <button
                  type="button"
                  onClick={onClose}
                  className="rounded-full p-1.5 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800"
                  aria-label="Tutup"
                >
                  <IoClose size={22} />
                </button>
              )}
            </div>

            <div className="flex-1 overflow-y-auto p-3 md:p-4">
              <div className="space-y-3">
                {sortByUnits.map((unit) => (
                  <button
                    key={unit.value}
                    type="button"
                    onClick={() => handleSelect(unit.value)}
                    className={`w-full rounded-xl border p-3 text-left transition-all duration-200 ${
                      selectedValue === unit.value
                        ? "border-secondary bg-secondaryActive"
                        : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <p className="font-medium text-slate-700">{unit.label}</p>
                      <div
                        className={`flex h-5 w-5 items-center justify-center rounded-full border ${
                          selectedValue === unit.value
                            ? "border-secondary bg-secondary"
                            : "border-gray-300"
                        }`}
                      >
                        {selectedValue === unit.value && (
                          <div className="h-3 w-3 rounded-full bg-white" />
                        )}
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default SwipeSortBy;
